<app-form-field
  [label]="label"
  [required]="required"
  [optional]="optional"
  [control]="control"
  [submitted]="submitted"
  [errorMessages]="errorMessages"
  [serverError]="serverError"
>
  <input
    class="form-control"
    [class.is-invalid]="isInvalid"
    [formControl]="formControl"
    [type]="type"
    [id]="id"
    [placeholder]="placeholder"
    [attr.maxlength]="maxlength"
    [attr.minlength]="minlength"
    [attr.readonly]="readonly ? true : null"
    [attr.pattern]="pattern"
    [autocomplete]="autocomplete"
    (keypress)="keypress.emit($event)"
    (input)="input.emit($event)"
    (paste)="paste.emit($event)"
    (focus)="focus.emit($event)"
    (focusout)="focusout.emit($event)"
  />
</app-form-field>
